import React from 'react'

function Delivery() {
  return (
    <>
    <div className='client'>
     <div className='container py-5'>
      <div className='row justify-content-center text-center'>
        <div className='col-lg-6'>
         <h1>Our Client Say!</h1>
         <p className='text-secondary py-4 fs-6'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A aliquam amet animi blanditiis consequatur debitis dicta distinctio, enim error eum iste libero modi nam natus perferendis possimus quasi sint sit tempora voluptatem.</p>
         <div className='d-flex justify-content-center pt-3'>
          <div>
          <h6>Daisy Lana</h6>
          <h6 className='text-danger'>Designer</h6></div>
         <img className='flex-end px-3' src={require('../images/user1.jpg')}/></div>
         </div>
         </div>
      </div>
      </div>
    <div className='free'>
     <div className='container'>
        <div className='row'>
            <div className='col-lg-4 text-center border-end'>
             <i class="bi bi-truck van"></i>
             <h5 className='fw-semibold pt-2 pb-1'>Free Delivery</h5>
             <p className='text-secondary fs-5 lh-base'>If you are going to use of Lorem, you need to be sure there anything</p>
            </div>
            <div className='col-lg-4 text-center border-end'>
             <i class="bi bi-currency-dollar van"></i>
             <h5 className='fw-semibold pt-2 pb-1'>30 Day Return</h5>
             <p className='text-secondary fs-5 lh-base'>If you are going to use of Lorem, you need to be sure there anything</p>
            </div>
            <div className='col-lg-4 text-center'>
             <i class="bi bi-headphones van"></i>
             <h5 className='fw-semibold pt-2 pb-1'>27/4 Support</h5>
             <p className='text-secondary fs-5 lh-base'>If you are going to use of Lorem, you need to be sure there anything</p>
            </div>
        </div>
     </div> 
     </div>
    
    </>
  )
}

export default Delivery
